import React, { FC } from 'react';
import { useQuery } from '@tanstack/react-query';
import * as reviewApi from '../../../api/review';
import Select, { Props as SelectProps } from 'react-select';
import { ReviewPublicationStatusType } from '../../../interfaces/review';


interface IProps extends Omit<SelectProps, 'options'> {
    label?: string;
}

const NonPublishedReasonFilter: FC<IProps> = ({  label, ...rest }) => {
    const {data = []} = useQuery({
        queryKey: ['review', 'publicationauxiliarystatuses'],
        queryFn: () => reviewApi.getReviewPublicationAuxStatuses()
    });

    const options = data
        .filter((item: any) => item.PublicationStatusKeyName === ReviewPublicationStatusType.NotPublished)
        .map((item: any) => ({
            label: item.ExternalDescription,
            value: `${item.PublicationAuxiliaryStatusID}`
    }));

    return (
        <div className="form-component form-inline form-select">
            {label && <label htmlFor={rest.id}>{label}</label>}
            <Select
                options={options}
                classNamePrefix='select'
                unstyled
                {...rest}
            />
        </div>
    );
};

export { NonPublishedReasonFilter };